<hyperkit-dialog class="hyperkit-component" headerText="Edit User">
  <div class="container-fluid">
    <div class="row">
      <div class="container">
        @if (error) {
          <hyperkit-error [error]="error"></hyperkit-error>
        }
        <form
          class="k-form"
          [formGroup]="formGroup"
          autocomplete="off"
          (ngSubmit)="onSubmit()"
        >
          <kendo-formfield>
            <label for="firstName">First Name*</label>
            <input
              id="firstName"
              formControlName="firstName"
              maxlength="50"
              kendoTextBox
            />
            <kendo-formerror>Error: First name is required</kendo-formerror>
          </kendo-formfield>
          <kendo-formfield>
            <label for="lastName">Last Name*</label>
            <input
              id="lastName"
              formControlName="lastName"
              maxlength="50"
              kendoTextBox
            />
            <kendo-formerror>Error: Last name is required</kendo-formerror>
          </kendo-formfield>
          <kendo-formfield>
            <label for="email">Email*</label>
            <input
              id="email"
              formControlName="email"
              maxlength="50"
              kendoTextBox
            />
            @if (formGroup.controls.email.errors?.required) {
              <kendo-formerror>Error: Email is required</kendo-formerror>
            }
            @if (formGroup.controls.email.errors?.email) {
              <kendo-formerror>Error: Not valid email format</kendo-formerror>
            }
          </kendo-formfield>
          <kendo-formfield>
            <label for="role">Role*</label>
            <kendo-dropdownlist formControlName="role" [data]="roles">
            </kendo-dropdownlist>
          </kendo-formfield>
          <hyperkit-button
            size="small"
            type="submit"
            color="tertiary"
            text="Save"
            [disabled]="!formGroup.valid"
          ></hyperkit-button>
        </form>
      </div>
    </div>
  </div>
</hyperkit-dialog>
